import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { FaxHooks } from '@frontend/api-fax';
import { useAppScopeSelection } from '@frontend/scope';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useFaxCountEventSubscription = () => {
  const invalidateFaxCount = FaxHooks.useInvalidateFaxCount();
  const { selectedLocationIds } = useAppScopeSelection();

  return useWebsocketEventSubscription(NotificationType.FAX_COUNT_CHANGE, (payload) => {
    // BE will send fax events to all users - location agnostic,
    // so we need to check if the event is relevant to the user's selected locations before processing it.
    if (!!payload.params.locationId && !selectedLocationIds.includes(payload.params.locationId)) {
      return;
    }

    invalidateFaxCount();
  });
};
